import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useConfiguration from '../../hooks/useConfiguration';
import DropDown from '../common/SearchableSelect';
import DateField from '../common/TextField/dateTime';
import KendoSchedulerDailyEncounter from '../kendoUI/Scheduler/dailyEncounter/KendoSchedulerDailyEncounter';
import {
  updateJobInfoDetails,
  updateRecusionFlag,
  updateShift,
  updateTemplateDescJobInfo,
  getAuthUsers,
  getFilterDailyEncounter,
  recurrenceStructring,
  getCheckMarkUpValue,
  masterDataBasedonJobLevel,
  setCertification,
  setMedicalSpecialities,
  setEMREHRSystemExperience,
  totalShiftAmountCalculation
} from './action';
import MultiShift from './multishift';
import { jobOpportunitySelector } from './selector';
import {
  setJobEncounterOccurreneUpdateList,
  setJobShiftAmountMultishiftOccurreneUpdateList,
  setjobMultishiftOccurreneUpdateList,
  setSelectedAuthUsers,
  setGrouping,
  setencounterCalculation,
  setShowCalenderModal,
  updateEditDayDate,
  setchekMarkup,
  setAuthUsers,
  setShowDailyCalendar,
  setPayRateType,
  updateSingleShiftEndDate
} from './slice';
import MultiSelectBox from '../common/ReactMultiSelect/MultiSelectBox';
import * as Toasts from '../common/Toastify';
import { setCandidateSearch } from '../ShiftsCoverage/slice';
import { payRateTypeObj, shiftTypeObj } from '../../helpers/data';
import moment from 'moment';
import { getSingleShiftEndDate } from './transformer';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const { masterData, shift, recursionFlag, jobInfo, authUsersList, selectedAuthUsers, grouping, location, currentSchedularDate, selectedOption } = useSelector(
    jobOpportunitySelector
  );
  const JobEncounterOccurreneUpdateList = useSelector(
    (state) => state.jobOpportunity.JobEncounterOccurreneUpdateList
  );
  // const [shiftDateError, SetShiftDateError] = useState(false);
  const dispatch = useDispatch();
  const config = useConfiguration();
  // const [shiftStartTimeList,setShiftStartTimeList] = useState([])
  // const [shiftEndTimeList,setShiftEndTimeList] = useState([])
  useEffect(() => {
    if (jobInfo?.jobCategory?.id && location?.locationNameInfo?.id && parseInt(recursionFlag) === 2 && config.baseUrl) {
      const payload = {
        "shiftPositionTitleId": jobInfo?.jobCategory?.id,
        "locationId": location?.locationNameInfo?.id
      }
      dispatch(getAuthUsers(config.baseUrl, payload)).then(response => {
          const candidate = [];
         if (response?.length) {
          response.forEach((item) => {
            candidate.push({
              value: item.candidateUniqueId,
              label: item.candidateFullName,
            });
          });
        }
        dispatch(setAuthUsers(candidate))
      })
    }
  }, [jobInfo?.jobCategory?.id, location?.locationNameInfo?.id ,recursionFlag, config.baseUrl])
  // useEffect(() => {
  //   if(selectedAuthUsers || grouping){
  //     dispatch(setSelectedAuthUsers([]))
  //     dispatch(setGrouping({ key: "group", value: [] }));
  //     dispatch(setGrouping({ key: "resources", value: [] }));
  //     dispatch(setencounterCalculation([]))
  //   }
  // },[ location?.locationNameInfo?.id])


  const updateShiftDetails = (target) => {
    dispatch(setShowCalenderModal(false))
    // dispatch(setjobMultishiftOccurreneUpdateList([]));
    // dispatch(setJobShiftAmountMultishiftOccurreneUpdateList([]));
    dispatch(updateEditDayDate([]))
    const value = target.value;
    const name = target?.name;
    if (name === "endTime") {
      dispatch(setjobMultishiftOccurreneUpdateList([]));
    }
    if (target.action === 'remove') {
      dispatch(updateShift(target.name, ''));
    } else {
      console.log({target,value,name});
      dispatch(updateShift(target.name, value)).then(() => {
        dispatch(recurrenceStructring());
      })
    }
    if(name=== "date" && (+recursionFlag === shiftTypeObj.singleShift)){
      const singleShiftEndDate = getSingleShiftEndDate(value,shift?.startTime?.id,shift?.preferedShift?.id);
      dispatch(updateSingleShiftEndDate(singleShiftEndDate))
      // if(shift?.preferedShift && shift?.startTime){
      //   console.log("enterrr");
      //   const shiftStartDateTime = moment(value+" "+shift?.startTime?.id, "YYYY-MM-DD hh:mm A");
      //   const hours = Math.floor(parseInt(shift?.preferedShift?.id) / 60);
      //   const minutes = shift?.preferedShift?.id  % 60;
      //   const shiftEndDateTime = shiftStartDateTime.add(hours,'hours').add(minutes,'minute');
      //    const shiftEndDate = shiftEndDateTime.format("YYYY-MM-DD");
      //    console.log({shiftEndDate,hours,minutes,value,pref: shift?.preferedShift});
      //   dispatch(updateSingleShiftEndDate(shiftEndDate))
      // } else {
      //   console.log("exit");
        
      // }
    }
    if( name=== "date" && +recursionFlag === shiftTypeObj.multiShift){
      dispatch(totalShiftAmountCalculation())
    }
  };
  const updateEndShiftDetails = (target) => {
    const value = target.value;
    dispatch(setShowCalenderModal(false))
    // dispatch(setjobMultishiftOccurreneUpdateList([]));
    dispatch(updateEditDayDate([]))
    if (target.action === 'remove') {
      dispatch(updateShift(target.name, ''));
    } else {
      dispatch(updateShift(target.name, value)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
    if(+recursionFlag === shiftTypeObj.multiShift){
      dispatch(totalShiftAmountCalculation())
    }
  };
  const updateSingleShiftEndDateHandler = target => {
  }
  const recurssionFlag = (target) => {
    // if (target.value === '3') {
    //   if (shift?.date === '') {
    //     SetShiftDateError(true);
    //     return;
    //   } else {
    //     SetShiftDateError(false);
    //   }
    // }
    if (target?.value?.id !== '') {
      dispatch(updateRecusionFlag(target?.value?.id));
    }
    // console.log(target?.value?.id);
    if(+target?.value?.id === 2){
      dispatch(setPayRateType({name:"payRateType",value:payRateTypeObj?.systemCal}))
    } 
    // else if (+target?.value?.id !== 3) {
    //   dispatch(setPayRateType({name:"payRateTotalShiftAmount",value:0}))
    // }
  };

  const handleCalenderModalSave = (value) => {
    console.log(`🚀 ~ file: shiftInfo.js ~ line: 50 :`, {
      value,
      JobEncounterOccurreneUpdateList,
    });
    if (value.length === 0 && JobEncounterOccurreneUpdateList.length > 0) {
      dispatch(
        setJobEncounterOccurreneUpdateList(
          JSON.parse(JSON.stringify(JobEncounterOccurreneUpdateList))
        )
      );
    } else {
      dispatch(
        setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify(value)))
      );
    }
  };
  const updateJobInfo = (target) => {
    if (target.name === 'jobTemplate') {
      dispatch(updateTemplateDescJobInfo(`${config.baseUrl}`, target.value));
    } else if (target.name === 'jobCategory') {
      dispatch(
        updateJobInfoDetails(`${config.baseUrl}`, 'jobTitle', target.value.name)
      );
    }
    dispatch(
      updateJobInfoDetails(`${config.baseUrl}`, target.name, target.value)
    );
    dispatch(setSelectedAuthUsers([]))
    dispatch(
      setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify([])))
    );

    dispatch(setGrouping({ key: "group", value: [] }));
    dispatch(setGrouping({ key: "resources", value: [] }));
    dispatch(setCandidateSearch({ key: "fromDate", value: "" }));
    dispatch(setCandidateSearch({ key: "toDate", value: "" }));
    dispatch(setCandidateSearch({ key: "candidates", value: "" }));
    dispatch(setencounterCalculation([]))
    // dispatch(getAuthUsers(config.baseUrl, target.value?.id));

    dispatch(setEMREHRSystemExperience({
      definedExperience: [],
      otherExperience: [
          {
              name: '',
              mandatory: false
          }
      ]
  }));
  dispatch(setMedicalSpecialities({
      speciality: [],
      otherSpeciality: [
          {
              name: '',
              yearsOfExperience: 0
          }
      ]
  }));
  dispatch(setCertification({
      definedCertification: [],
      otherCertification: [
          {
              name: '',
              mandatory: false
          }
      ]
  }));
  props?.specialitySelectRef.current.resetSelectedValues()
  props?.certificationRef.current.resetSelectedValues()
  props?.emrehrRef.current.resetSelectedValues()
    const params = {
      jobLevel:[target.value.id]
    }
    dispatch(masterDataBasedonJobLevel({url:config.baseUrl,params}))

  };
  const listValue = [
    { id: 1, name: 'Single Shift' },
    { id: 3, name: 'MultiShift' },
    { id: 2, name: 'Daily Encounters' },
  ];

  const handleActions = (payload) => { };

  const updateAuthorizedUser = (target) => {
    dispatch(setSelectedAuthUsers(target.value))
  }

  const getShedule = () => {
    if (selectedAuthUsers?.length > 0) {
      dispatch(setShowDailyCalendar(true))
    } else {
      dispatch(setShowDailyCalendar(false))
    }
    dispatch(
      setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify([])))
    );

    dispatch(setGrouping({ key: "group", value: [] }));
    dispatch(setGrouping({ key: "resources", value: [] }));
    dispatch(setCandidateSearch({ key: "fromDate", value: "" }));
    dispatch(setCandidateSearch({ key: "toDate", value: "" }));
    dispatch(setCandidateSearch({ key: "candidates", value: "" }));
    dispatch(setencounterCalculation([]))
    if ((!selectedAuthUsers?.length > 0)) {
      Toasts.error("Please select Authorized User");
      return
    }

    const reauest = {
      "jobsShiftUniqueId": null,
      "candidates": [
        ...new Set(
          selectedAuthUsers.map((element) => element.value)
        ),
      ],
      "fromDate": currentSchedularDate,
      "toDate": currentSchedularDate,
       "locationId": location?.locationNameInfo?.id
    }

    dispatch(
      getFilterDailyEncounter(config.baseUrl, reauest)
    ).then((resource) => {
      console.log(resource);
      if (resource && resource.length) {
        const groupArray = [
          ...new Set(
            resource.map((element, index) => {
              return element.name;
            })
          ),
        ];
        dispatch(setGrouping({ key: "group", value: groupArray }));
        dispatch(setGrouping({ key: "resources", value: resource }));
      }
    })
  }
  // console.log({def:shift.startTime ,totaList:masterData?.allShiftStartTime, shiftStartTimeList});
  // const getShiftTimeList = (masterTimeList,currrentTime,setTimeList) => {
  //   const findIndex = masterTimeList?.findIndex(item => item?.id === currrentTime?.id)
  //   if(findIndex > -1){
  //     const firstSlcie = masterTimeList?.slice(0,findIndex);
  //     const secondSlice = masterTimeList?.slice(findIndex);
  //     // console.log({result:secondSlice?.concat(firstSlcie)});
  //     setTimeList(secondSlice?.concat(firstSlcie))
  //   }
  // }
  // useEffect(() =>{
  //   if(selectedOption.fromTemplate){
  //     if(shift?.startTime && masterData?.allShiftStartTime){
  //       getShiftTimeList(masterData?.allShiftStartTime , shift?.startTime, setShiftStartTimeList)
  //     }
  //     if(shift?.endTime && masterData?.allShiftEndTime){
  //       getShiftTimeList(masterData?.allShiftEndTime, shift?.endTime ,  setShiftEndTimeList)
  //     }
  //   } else{
  //     setShiftStartTimeList([])
  //     setShiftEndTimeList([])
  //   }
  // },[selectedOption , shift.startTime,masterData?.allShiftStartTime, shift?.endTime ,masterData?.allShiftEndTime])

  useEffect(() => {

    if (config.baseUrl && location?.locationNameInfo?.id && jobInfo?.jobCategory?.id && shift?.date) {
      const params = {
        "locationId": location?.locationNameInfo?.id,
        "jobCategoryId": jobInfo?.jobCategory?.id,
        "shiftDate": shift?.date
      }

      dispatch(getCheckMarkUpValue(`${config.baseUrl}`, params)).then(request => {
        // console.log(request, '---------------------');
        dispatch(setchekMarkup(request));
      });
    }
  }, [config, shift?.date, location?.locationNameInfo?.id, jobInfo?.jobCategory?.id])

  const getCurrentTime = (masterStartTimeData) => {
    let hours = new Date().getHours();
    const minutes = new Date().getMinutes();
    const slot = 15;
    let roundUpMinutes = Math.ceil(minutes / slot) * slot;
    if(parseInt(roundUpMinutes) === 60){
      hours++
      roundUpMinutes='00'
    }
    const timeCompareFormat = `${String(hours).padStart(2, '0')}:${String(roundUpMinutes).padStart(2, '0')}:00`
    const result = masterStartTimeData?.find(item => item?.id === timeCompareFormat)
  //  console.log({result,hours,minutes,timeCompareFormat});
    dispatch(updateShift("startTime", result))
    // return result ? [result]:[]
  }
  const getShiftLength = (masterShiftLength) => {
    const aDayInMins = 24 * 60;
    let shiftLengthList = [];
    if(masterShiftLength?.length > 0){
      if(+recursionFlag !== shiftTypeObj.singleShift){
        shiftLengthList = masterShiftLength?.filter(length => length?.id <= aDayInMins);
      } else {
        shiftLengthList = masterShiftLength;
      }
    }
    return shiftLengthList
  }
  return (
    <div className="card">
      <div className='col-12'>
        <div className="row">
          <div className="card-header">
            <h3 class="card-title">
              Shift Info <span className="required">*</span>
            </h3>
          </div>
          <div className="card-body">
            {/* <div className="row mb-4">
            <div className="col-lg-4 col-md-4">
              <label htmlFor={'recurrence'}>Recurrence</label>
              <div>
                <select
                  className="form-select recurssion-select"
                  disabled={props.RecurrenceDisabled}
                  value={recursionFlag}
                  onChange={(e) => {
                    recurssionFlag(e.target);
                  }}
                >
                  <option value={1}>Single Shift</option>
                  <option value={3}>MultiShift</option>
                  <option value={2}>Daily Encounter</option>
                </select>
              </div>
            </div>

          </div> */}
            <div className="row">
              {/* <DropDown
                isDisabled  = {selectedOption?.editJobPost }
                name={'recurrence'}
                // id={"jobCategory"}
                label="Recurrence"
                options={listValue}
                disabled={props.RecurrenceDisabled}
                value={[
                  recursionFlag
                    ? listValue.find(
                      (item) => item.id === parseInt(recursionFlag)
                    )
                    : [],
                ]}
                multiple={false}
                updateValue={recurssionFlag}
                isObject={true}
                divClass={'col-lg-3 col-md-3'}
              /> */}
              {
                parseInt(recursionFlag) === 3 ? <DropDown
                  name={'jobCategory'}
                  id={'jobCategory'}
                  label="Shift Position Title "
                  star="*"
                  options={masterData?.allJobCategory}
                  value={jobInfo.jobCategory ? [jobInfo?.jobCategory] : []}
                  multiple={false}
                  updateValue={updateJobInfo}
                  isObject={true}
                  errors={props.errors ? props.errors['jobCategory'] : []}
                  divClass={'col-lg-3 col-md-3'}
                /> : ""
              }
              {parseInt(recursionFlag) === 2 ? (
                <>
                  <DropDown
                    name={'jobCategory'}
                    id={'jobCategory'}
                    label="Shift Position Title "
                    star="*"
                    options={masterData?.allJobCategory}
                    value={jobInfo.jobCategory ? [jobInfo?.jobCategory] : []}
                    multiple={false}
                    updateValue={updateJobInfo}
                    isObject={true}
                    errors={props.errors ? props.errors['jobCategory'] : []}
                    divClass={'col-lg-3 col-md-3'}
                  />
                  <MultiSelectBox
                    name="authorizedUser"
                    title="Authorized User"
                    value={selectedAuthUsers}
                    options={authUsersList}
                    updateValue={updateAuthorizedUser}
                    isMultiSelect={true}
                    hideSelectedOptions={true}
                    closeListOnSelect={false}
                    isMandatory={true}
                    divClass={`col-lg-3 col-md-3`}
                    errors={props.errors ? props.errors['authorizedUser'] : []}
                  />
                  <div className='col-lg-3 col-md-3'>
                    <button
                      style={{ marginTop: "1.75rem" }}
                      className="btn btn-primary"
                      type="button"
                      onClick={getShedule}
                    >
                      Get Schedule
                    </button>
                  </div>
                </>
              ) : (
                ''
              )}
            </div>
            <div className="row">
              {parseInt(recursionFlag) !== 2 ? (
                <>
                  <DateField
                    name={'date'}
                    star="*"
                    divClass={`${parseInt(recursionFlag) === 3 ? 'col-lg-3 col-md-3' : 'col-lg-3 col-md-3'}`}
                    label={'Start Date'}
                    id={'date'}
                    value={shift?.date}
                    updateValue={updateShiftDetails}
                    includeTime={false}
                    errors={props.errors['shiftDate']}
                    isMandatory={'yes'}
                  />
                   {+recursionFlag === shiftTypeObj.singleShift && (
                    <DateField
                    isDisabled={true}
                      name={"singleShiftEndDate"}
                      divClass={`${
                        parseInt(recursionFlag) === 3
                          ? "col-lg-3 col-md-3"
                          : "col-lg-3 col-md-3"
                      }`}
                      label={"End Date"}
                      id={"singleShiftEndDate"}
                      value={shift?.singleShiftEndDate}
                      updateValue={updateSingleShiftEndDateHandler}
                      includeTime={false}
                      // errors={props.errors["singleShiftEndDate"]}
                    />
                  )}
                  {
                    parseInt(recursionFlag) === 3 ? <DateField
                      name={'endDate'}
                      star="*"
                      divClass={`${parseInt(recursionFlag) === 3 ? 'col-lg-3 col-md-3' : 'col-lg-3 col-md-3'}`}
                      label={'End Date'}
                      id={'enddate'}
                      value={shift?.endDate}
                      updateValue={updateEndShiftDetails}
                      includeTime={false}
                      errors={props.errors['endDate']}
                      isMandatory={'yes'}
                    /> : ""
                  }
                  <DropDown
                    name={'preferedShift'}
                    divClass={`col-lg-2 col-md-2`}
                    label={'Shift Length'}
                    star="*"
                    id={'preferedShift'}
                    options={getShiftLength(masterData?.allPreferedShifts) ?? masterData?.allPreferedShifts }
                    multiple={false}
                    value={shift.preferedShift ? [shift.preferedShift] : []}
                    updateValue={updateShiftDetails}
                    isObject={true}
                    errors={props.errors ? props?.errors['preferedShift'] : []}
                  />
                  <DropDown
                    name={'startTime'}
                    divClass={`col-lg-2 col-md-2`}
                    label={'Shift Start Time'}
                    star="*"
                    id={'startTime'}
                    options={masterData?.allShiftStartTime}
                    // options={shiftStartTimeList.length ? shiftStartTimeList : masterData?.allShiftStartTime}
                    multiple={false}
                    value={shift.startTime ? [shift?.startTime] : getCurrentTime(masterData?.allShiftStartTime)}
                    updateValue={updateShiftDetails}
                    isObject={true}
                    errors={props.errors ? props?.errors['startTime'] : []}
                  />
                  <DropDown
                    name={'endTime'}
                    divClass={`col-lg-2 col-md-2`}
                    label={'Shift End Time'}
                    star="*"
                    id={'endTime'}
                    options={masterData?.allShiftEndTime}
                    // options={shiftEndTimeList.length ? shiftEndTimeList : masterData?.allShiftEndTime}
                    multiple={false}
                    value={shift.endTime ? [shift?.endTime] : []}
                    updateValue={updateShiftDetails}
                    isObject={true}
                    errors={props.errors ? props.errors['endTime'] : []}
                  />
                </>
              ) : (
                ''
              )}
            </div>

            <div className="row">
              {recursionFlag?.toString() === '3' && (
                <MultiShift errors={props.errors} />
              )}
              {recursionFlag?.toString() === '2' && (
                <>
                  <KendoSchedulerDailyEncounter
                    startDate={shift?.fullFormatDate ? shift?.fullFormatDate : shift.date}
                    handleSave={handleCalenderModalSave}
                    multiShiftData={JobEncounterOccurreneUpdateList}
                    grouping={{
                      default: true,
                      group: grouping.group,
                      resources: grouping.resources,
                      showWeek: false,
                      showMonth: false,
                      // showNextPrevious:false
                      changeCurrentSchedularDate: true
                    }}
                    handleActions={handleActions}
                  />
                  {props?.errors && props?.errors['encounterList'] ? props?.errors['encounterList']?.map(error => (<div className="invalid-input">{error}</div>)) : []}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
